import type en from "../en/ai";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  dockButton: "اسأل الذكاء الاصطناعي",
  dockTitle: "المساعد الذكي",
  openFull: "فتح في صفحة كاملة",
  contextPage: "يعمل على الصفحة المفتوحة في المحرر",
  editorStale: "قام المساعد بتعديل هذا المتجر. أعد تحميل المحرر لرؤية آخر مسودة قبل متابعة التعديل.",
  reloadEditor: "إعادة تحميل المحرر",
  unavailableTitle: "المساعد الذكي غير متاح",
  unavailableBody: "لم يتم إعداد مزوّد للذكاء الاصطناعي على هذا الخادم. يجب على المسؤول إضافة مفتاح OpenAI (الإدارة ← الذكاء الاصطناعي والأرصدة ← مختبر الأصوات) أو ضبط ANTHROPIC_API_KEY. باقي لوحة التحكم يعمل بشكل طبيعي.",
  introEdit: "أخبرني بما تريد تغييره كتابةً أو بصوتك. أعدّل مسودات يمكنك معاينتها قبل نشر أي شيء.",
  introCreate: "صف المتجر الذي تريده: ماذا تبيع، ولمن، وأسلوبك وبلدك. سأنشئه وأجهّز الصفحات والتصميم والقوائم.",
  safetyNote: "لا أغيّر الأسعار أو المخزون أو المدفوعات أو النطاقات أبدًا، وأطلب تأكيدك قبل النشر أو الحذف.",
  suggestHero: "اجعل لافتة الصفحة الرئيسية أكثر فخامة وأضف قسم مزايا تحتها",
  suggestFaq: "أضف أسئلة شائعة عن الشحن والإرجاع إلى صفحة الأسئلة الشائعة",
  suggestColors: "استخدم لوحة ألوان أخضر داكن وكريمي مع خط عناوين مزخرف",
  suggestTranslate: "أضف الفرنسية إلى متجري وترجم الصفحات",
  suggestCreate1: "متجر للخزف المغربي المصنوع يدويًا يبيع في أوروبا، بأسلوب دافئ وترابي، والأسعار باليورو",
  suggestCreate2: "علامة ملابس شارع بسيطة في الولايات المتحدة بتصميم أسود وأبيض جريء",
  placeholderEdit: "مثال: «غيّر عنوان اللافتة إلى …»",
  placeholderCreate: "مثال: أريد إنشاء متجر للجاكيتات باسم Jaketo — جاكيتات رجالية فقط، العملة درهم مغربي، المتجر في المغرب، الموقع بالفرنسية، بأسلوب عصري أسود وأبيض…",
  inputLabel: "رسالة إلى المساعد",
  send: "إرسال",
  working: "جارٍ العمل…",
  thinking: "يفكّر…",
  speak: "تحدّث",
  stopListening: "إيقاف الاستماع",
  listening: "أستمع… تحدّث الآن",
  spoken: "منطوق",
  speakReplies: "قراءة الردود بصوت عالٍ",
  enterHint: "Enter للإرسال · Shift+Enter لسطر جديد",
  stepsLabel: "ما قام به المساعد",
  confirmTitle: "يرجى التأكيد",
  savedAsDraft: "حُفظ كمسودة",
  live: "منشور",
  previewChanges: "معاينة التغييرات ↗",
  undoChanges: "التراجع عن هذه التغييرات",
  connectionLost: "انقطع الاتصال قبل وصول الطلب إلى الخادم. حاول مرة أخرى.",
  connectionLostRunning: "انقطع الاتصال، لكن المساعد يواصل العمل على الخادم. أعد المحاولة لرؤية النتيجة — لن يُنفَّذ الطلب مرتين.",
  voiceUnsupported: "الإدخال الصوتي غير مدعوم في هذا المتصفح. استخدم إصدارًا حديثًا من Chrome أو Edge أو Safari، أو اكتب طلبك.",
  voicePermissionDenied: "تم حظر الوصول إلى الميكروفون. اسمح بالميكروفون لهذا الموقع من إعدادات المتصفح، أو اكتب طلبك.",
  voiceNoMic: "لم يتم العثور على ميكروفون. وصّل ميكروفونًا أو اكتب طلبك.",
  voiceNoSpeech: "لم أسمع شيئًا. اضغط على الميكروفون وحاول مجددًا.",
  voiceNetwork: "تعذّر الوصول إلى خدمة الكلام في المتصفح. تحقق من اتصالك أو اكتب طلبك.",
  voiceAborted: "توقف الاستماع.",
  voiceFailed: "فشل الإدخال الصوتي. يرجى كتابة طلبك.",
  tool_get_store_overview: "قراءة بيانات المتجر",
  tool_get_page: "قراءة الصفحة",
  tool_list_section_types: "التحقق من الأقسام المتاحة",
  tool_list_media: "استعراض صورك",
  tool_list_products: "استعراض منتجاتك",
  tool_list_collections: "استعراض مجموعاتك",
  tool_edit_page_sections: "تعديل أقسام الصفحة",
  tool_create_page: "إنشاء صفحة",
  tool_update_page_details: "تحديث تفاصيل الصفحة",
  tool_publish_page: "نشر الصفحة",
  tool_delete_page: "حذف صفحة",
  tool_set_theme: "تغيير القالب",
  tool_update_theme_settings: "تحديث الألوان والخطوط",
  tool_publish_theme: "نشر القالب",
  tool_update_menu: "تحديث القوائم",
  tool_update_store_details: "تحديث وصف المتجر",
  tool_update_product_text: "إعادة كتابة نص المنتج",
  tool_create_collection: "إنشاء مجموعة",
  tool_enable_storefront_language: "إضافة لغة إلى واجهة المتجر",
  tool_get_translation_status: "التحقق من الترجمات",
  tool_translate_content: "ترجمة المحتوى",
  tool_publish_storefront_language: "نشر لغة",
  tool_publish_store: "نشر المتجر",
  tool_set_dashboard_language: "تغيير لغة لوحة التحكم",
  tool_create_store: "إنشاء متجرك",
  pageTitle: "المساعد الذكي",
  pageDescription: "أنشئ متجرك وعدّله بالكتابة أو بالصوت. يستخدم النص والصوت المساعد نفسه وسجل التغييرات نفسه.",
  historyTitle: "سجل التغييرات",
  historyDescription: "كل ما قام به المساعد لك في هذا المتجر، من الأحدث إلى الأقدم.",
  historyEmpty: "لا توجد تغييرات من المساعد حتى الآن.",
  status_running: "قيد التنفيذ",
  status_awaiting_confirmation: "بانتظار التأكيد",
  status_succeeded: "تم",
  status_partial: "تم جزئيًا",
  status_failed: "فشل",
  status_cancelled: "أُلغي",
  outcome_draft: "مسودة",
  outcome_published: "منشور",
  outcome_none: "بلا تغييرات",
  stepUndone: "تم التراجع",
  viaVoice: "بالصوت",
  viaText: "بالكتابة",
  undo: "تراجع",
  undoing: "جارٍ التراجع…",
  createTitle: "أنشئ متجرًا بالذكاء الاصطناعي",
  createDescription: "صف نشاطك التجاري وسيبني المساعد نسخة أولى من متجرك: القالب والألوان والصفحة الرئيسية والصفحات والقوائم. لا يُنشر شيء إلا بقرارك.",
  createManual: "تفضّل نموذجًا؟ أنشئ متجرًا يدويًا",
  storeReady: "متجرك جاهز للمراجعة.",
  openStore: "فتح لوحة تحكم المتجر",
  levelLabel: "جودة النموذج",
  level_low: "منخفض",
  level_medium: "متوسط",
  level_high: "عالٍ",
  level_max: "أقصى",
  levelTooltip: "{level} ≈ ×{multiplier}",
  levelLocked: "المستوى {level} غير متاح في خطتك",
  levelLowHint: "المستوى المنخفض غير مستحسن للبناء المعقد. أضف رصيدًا لاستخدام مستوى أعلى.",
  creditsLeft: "تبقّى {count} رصيد — اشحن لمواصلة البناء",
  outOfCredits: "نفد رصيدك — اشحن محفظتك لمواصلة البناء",
  fundWallet: "شحن المحفظة",
  addCredits: "إضافة رصيد",
  upgradePlan: "ترقية الخطة",
  chargeCredits: "−{credits} ⚡",
  chargeFree: "مجاني (ضمن الخطة)",
  chargeTitle: "تكلفة هذا الرد",
  planButton: "خطة",
  planHint: "احصل على خطة خطوة بخطوة أولًا — دون أي تغيير",
  planLabel: "خطة",
  buildIt: "ابنِه",
  buildItText: "ابنِه كما هو مخطط.",
  attach: "إرفاق صورة",
  attachNeedsStore: "يمكنك إرفاق الصور بعد إنشاء متجرك",
  uploading: "جارٍ الرفع…",
  uploadFailed: "تعذّر رفع الصورة.",
  removeAttachment: "إزالة الصورة",
  attachedImage: "صورة مرفقة",
  stepsCount: "الخطوات {done}/{total}",
  queued: "في الانتظار: {text}",
  cancelQueued: "إزالة الرسالة المنتظرة",
  queuePlaceholder: "اكتب رسالتك التالية لتُرسل بعد الانتهاء…",
  stop: "إيقاف",
  phase_store: "إنشاء متجرك",
  phase_images: "إنشاء صور المشروع",
  phase_pages: "كتابة الصفحات",
  phase_styling: "تطبيق هوية العلامة",
  phase_navigation: "بناء قائمة التنقل",
  phase_translating: "الترجمة",
  phase_details: "تحديث بيانات المتجر",
  phase_publishing: "النشر",
  phase_reading: "مراجعة متجرك",
  phase_thinking: "التخطيط للخطوة التالية",
  phase_planning: "التخطيط للبناء",
  phase_working: "جارٍ العمل",
  phase_done: "تم",
  progressLog: "ما يقوم به المساعد",
  progressLabel: "تقدّم البناء",
  milestonesLabel: "قائمة مراحل البناء",
  chooseToContinue: "اختر إجابة للمتابعة",
  generating: "جارٍ الإنشاء…",
  ready: "جاهز",
  preparingWorkspace: "تجهيز مساحة العمل",
  previewWaiting: "سيظهر متجرك هنا بمجرد أن ينشئه المساعد.",
  livePreview: "معاينة مباشرة",
  openStudio: "فتح في استوديو الذكاء الاصطناعي",
  stepsPill: "الخطوات {done}/{total}",
  callBuilding: "جارٍ بناء متجرك…",
  callWatchLive: "شاهد مباشرة",
  backToDashboard: "العودة إلى لوحة التحكم",
  storeReadyTitle: "متجرك جاهز!",
  storeReadyBody: "يمكنك إدارته من لوحة التحكم: المنتجات، الطلبات، التصميم، الدفع والنشر.",
  storeReadyDashboard: "افتح لوحة التحكم",
  storeReadyDesign: "تابع التصميم",
  limitPlanTitle: "تم بلوغ حدّ خطتك",
  limitPlanBody: "خطتك الحالية لا تسمح بذلك (مثل إنشاء متجر آخر). قم بترقية خطتك للمتابعة — لم يتم خصم أي شيء.",
  limitCreditsTitle: "نفدت أرصدة الذكاء الاصطناعي",
  limitCreditsBody: "اشترِ أرصدة أو قم بترقية خطتك لمتابعة البناء.",
  limitLevelTitle: "مستوى النموذج هذا غير متاح في خطتك",
  limitLevelBody: "اختر مستوى أقل، أو قم بترقية خطتك لنماذج أقوى.",
  buyCredits: "شراء أرصدة",
  myStores: "متاجري",
};

export default ar;
